import React, { useState } from 'react';
import { X, Mail } from 'lucide-react';
interface SendPaymentLinkModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSend: (includeMessage: boolean, message: string) => void;
  customerEmail: string;
}
export function SendPaymentLinkModal({
  isOpen,
  onClose,
  onSend,
  customerEmail
}: SendPaymentLinkModalProps) {
  const [includeMessage, setIncludeMessage] = useState(false);
  const [message, setMessage] = useState('');
  if (!isOpen) return null;
  const handleSend = () => {
    onSend(includeMessage, message);
    onClose();
    // Reset state
    setIncludeMessage(false);
    setMessage('');
  };
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-[rgba(15,23,42,0.5)] z-[1040]" onClick={onClose} data-id="element-5424" data-mp="13mudfovwbxcy" />

      {/* Modal */}
      <div className="fixed inset-0 flex items-center justify-center z-[1050] p-4" data-id="element-5425" data-mp="30fe0yafghu3k">
        <div className="bg-white rounded-lg shadow-xl w-full max-w-[480px] animate-[ocean-scale-in_200ms_ease-in-out]" data-id="element-5426" data-mp="30hgyrgmuoriu">
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-4 border-b border-[#E2E8F0]" data-id="element-5427" data-mp="2uc45l12q4eaz">
            <div className="flex items-center gap-3" data-id="element-5428" data-mp="2pjb0ud7995yw">
              <div className="w-10 h-10 rounded-full bg-[#E0F2FE] flex items-center justify-center" data-id="element-5429" data-mp="2kl9973vrjybt">
                <Mail className="w-5 h-5 text-[#0EA5E9]" data-id="element-5430" data-mp="2fm6g8ht25ik7" />
              </div>
              <h2 className="text-[20px] font-semibold text-[#0F172A]" data-id="element-5431" data-mp="2fk3fp3ua4718">
                Send Payment Update Link
              </h2>
            </div>
            <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-md text-[#64748B] hover:bg-[#F1F5F9] hover:text-[#0F172A] transition-colors" data-id="element-5432" data-mp="38akf0zrz0iwt">
              <X className="w-5 h-5" data-id="element-5433" data-mp="2zafgzg8o2wvb" />
            </button>
          </div>

          {/* Body */}
          <div className="px-6 py-6" data-id="element-5434" data-mp="1rwc2zz4ttrzf">
            <p className="text-[14px] text-[#475569] mb-6" data-id="element-5435" data-mp="1rxdeu5to2ii7">
              Send a secure link to{' '}
              <span className="font-medium text-[#0F172A]" data-id="element-5436" data-mp="1nu7cvadl7dhj">
                {customerEmail}
              </span>{' '}
              to update their payment method?
            </p>

            {/* Include message checkbox */}
            <div className="space-y-4" data-id="element-5437" data-mp="1u965w4kvz8b1">
              <div className="flex items-start gap-3" data-id="element-5438" data-mp="1fehqnypoovi8">
                <input type="checkbox" id="includeMessage" checked={includeMessage} onChange={e => setIncludeMessage(e.target.checked)} className="w-[18px] h-[18px] mt-0.5 text-[#0EA5E9] border-2 border-[#CBD5E1] rounded focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20" data-id="element-5439" data-mp="1fdq3nca5k63k" />
                <label htmlFor="includeMessage" className="text-[14px] text-[#0F172A] font-medium cursor-pointer select-none" data-id="element-5440" data-mp="1bdxv2zkrdzy7">
                  Include custom message
                </label>
              </div>

              {/* Message textarea */}
              {includeMessage && <div className="animate-[ocean-slide-up_200ms_ease-in-out]" data-id="element-5441" data-mp="nmk1yresa0c6">
                  <label className="block text-[12px] font-medium text-[#475569] mb-1.5" data-id="element-5442" data-mp="ro5n101h1kxg">
                    Custom Message
                  </label>
                  <textarea value={message} onChange={e => setMessage(e.target.value)} placeholder="Add a personal note to the customer..." rows={4} className="w-full px-3 py-2.5 border border-[#CBD5E1] rounded-md bg-white text-[#0F172A] text-[14px] placeholder:text-[#94A3B8] focus:border-[#0EA5E9] focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20 outline-none transition-[border-color,box-shadow] duration-200 ease-in-out resize-none" data-id="element-5443" data-mp="90n0s85ijyzr" />
                  <p className="text-[12px] text-[#64748B] mt-1.5" data-id="element-5444" data-mp="mzw8skjkfmsn">
                    This message will be included in the email sent to the
                    customer.
                  </p>
                </div>}
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-[#E2E8F0]" data-id="element-5445" data-mp="wrsg8m7jkp9j">
            <button onClick={onClose} className="h-10 px-5 bg-white border border-[#CBD5E1] rounded-md text-[#0F172A] text-[14px] font-medium hover:bg-[#F1F5F9] hover:border-[#94A3B8] focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20 transition-all" data-id="element-5446" data-mp="1ancp0otk3r38">
              Cancel
            </button>
            <button onClick={handleSend} className="h-10 px-5 bg-[#0EA5E9] border border-[#0EA5E9] rounded-md text-white text-[14px] font-medium hover:bg-[#0284C7] hover:border-[#0284C7] focus:outline-none focus:ring-2 focus:ring-[#0EA5E9] focus:ring-opacity-20 transition-all" data-id="element-5447" data-mp="1yksfb5ryoc7q">
              Send Link
            </button>
          </div>
        </div>
      </div>
    </>;
}